// 商详改造营销承接页一些函数
const search = window.location.search
var urlParams = new URLSearchParams(search)
var view = urlParams.get('view')
if (view === 'marketing') {
  var style = $('<style type="text/css">').html('.needsclick { display: none !important; }');
  $('head').append(style);

  $('.product__container').addClass('marketing')
  document.addEventListener('DOMContentLoaded', function () {
    var contentContainer = $('#rich-text-description') // 替换为您的内容容器的ID
    var originalHtml = contentContainer.html()
    if (contentContainer) {
      var childElements = contentContainer.children() // 获取所有直接子元素
      var totalLinesHeight = 0 // 用于累计总行数高度
      var linesToShow = 4 // 需要显示的行数
      var currentElement = null // 需处理元素
      var currentLineHeight = 0 // 需处理元素的行高
      var currentLines = 0 // 需处理元素的行数

      // 遍历所有子元素
      for (var i = 0; i < childElements.length; i++) {
        var element = childElements[i]
        var lineHeight = parseFloat(getComputedStyle(element).lineHeight) // 获取行高
        var elementHeight = element.scrollHeight // 获取元素内容的高度
        // 计算当前元素可以显示的行数
        var linesInElement = Math.floor(elementHeight / lineHeight)
        if (element?.innerHTML) totalLinesHeight += linesInElement
        if (totalLinesHeight >= linesToShow) {
          currentElement = element
          currentLineHeight = lineHeight
          currentLines = linesInElement
          break
        }
      }

      if (!!currentElement) {
        if (!!currentLines) {
          // 计算需要截断的行数
          var linesToHide = totalLinesHeight - linesToShow
          // 计算截断后元素应该显示的高度
          var maxHeight = currentLineHeight * (currentLines - linesToHide)
          // 设置当前元素的最大高度为显示三行的高度
          $(currentElement).css({
            // maxHeight: `${maxHeight}px`,
            display: '-webkit-box',
            overflow: 'hidden',
            '-webkit-line-clamp': `${currentLines - linesToHide}`,
            webkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
          })
        }

        // 隐藏当前元素之后的所有元素
        for (var j = i + 1; j < childElements.length; j++) {
          $(childElements[j]).css({ display: 'none' })
        }

        $(currentElement).addClass('ellipsis')
        var handleHtml = contentContainer.html()
        $(contentContainer).after(`<div class="fold">Expand</div>`)
        $('.fold').click(function () {
          const text = $(this).html()
          if (text === 'Expand') {
            $(this).html('Fold')
            contentContainer.html(originalHtml)
          } else {
            $(this).html('Expand')
            contentContainer.html(handleHtml)
          }
        })
      }
    }
    document.getElementById('rich-text-description').style.visibility = 'visible'
  })
} else {
  $('.product__container').removeClass('marketing')
}
